import { render } from "./ssnInput.vue?vue&type=template&id=5c448929"
import script from "./ssnInput.vue?vue&type=script&lang=js"
export * from "./ssnInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__